var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsPdf01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13V10.657C20 9.839 20 9.431 19.848 9.063C19.696 8.696 19.407 8.406 18.828 7.828L14.092 3.092C13.593 2.593 13.344 2.344 13.034 2.196C12.9698 2.16518 12.9041 2.13781 12.837 2.114C12.514 2 12.161 2 11.456 2C8.211 2 6.588 2 5.489 2.886C5.26709 3.06494 5.06494 3.26709 4.886 3.489C4 4.59 4 6.211 4 9.456V13M13 2.5V3C13 5.828 13 7.243 13.879 8.121C14.757 9 16.172 9 19 9H19.5M19.75 16H17.25C16.9848 16 16.7304 16.1054 16.5429 16.2929C16.3554 16.4804 16.25 16.7348 16.25 17V19M16.25 19V22M16.25 19H19.25M4.25 22V19.5M4.25 19.5V16H6C6.46413 16 6.90925 16.1844 7.23744 16.5126C7.56563 16.8408 7.75 17.2859 7.75 17.75C7.75 18.2141 7.56563 18.6592 7.23744 18.9874C6.90925 19.3156 6.46413 19.5 6 19.5H4.25ZM10.25 16H11.75C12.2804 16 12.7891 16.2107 13.1642 16.5858C13.5393 16.9609 13.75 17.4696 13.75 18V20C13.75 20.5304 13.5393 21.0391 13.1642 21.4142C12.7891 21.7893 12.2804 22 11.75 22H10.25V16Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsPdf01);
export default __webpack_public_path__ + "static/media/hugeicons_pdf-01.c0e6888c5b78423fcd009ce4acfc68b9.svg";
export { ForwardRef as ReactComponent };